import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

export interface InputLabelProps {
  className?: string;
  label: string;
  disabled?: boolean;
}

export const InputLabel = ({
  className,
  label,
  disabled,
}: InputLabelProps): ReactElement => (
  <p
    className={twMerge(
      'text-sm font-black text-gray',
      disabled && 'text-gray-300',
      className,
    )}
  >
    {label}
  </p>
);
